import script from "./FormButtonSubmit.vue?vue&type=script&setup=true&lang=js"
export * from "./FormButtonSubmit.vue?vue&type=script&setup=true&lang=js"

import "./FormButtonSubmit.vue?vue&type=style&index=0&id=70cac12e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70cac12e"]])

export default __exports__